import CapitalizationUtil from "../../utils/CapitalizationUtil.ts";
import { GenericResponseType } from "../../types/response.ts";
import { COMMON_API_URL } from "../../constants/urls";

const postData = async (
  jwt: string,
  callfunc: string,
  additionalParams?: object
): Promise<string | object> => {
  const response = await fetch(`${COMMON_API_URL}/${callfunc}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify({ ...additionalParams }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data: GenericResponseType =
    CapitalizationUtil.convertTopLevelKeysToCamelCase(await response.json());

  if (data.error) {
    throw new Error(data.error);
  }

  return data.result.clientData ? data.result.clientData : data.result;
};

const ClientsService = {
  getAllCountries: (jwt: string) => postData(jwt, "getCountry"),
  getAllAreas: (jwt: string) => postData(jwt, "getDistrict"),
  getAllMunicipalities: (jwt: string, district: string) =>
    postData(jwt, "getMunicp", { district }),
  getAllCities: (jwt: string, municp: string) =>
    postData(jwt, "getTown", { municp }),
  getClient: (jwt: string, pin: string) =>
    postData(jwt, "getClient", { clPIN: pin }),
  getClientById: (jwt: string, clientId: string) =>
    postData(jwt, "getClientById", { CL_ID: clientId }),
  saveClient: (jwt: string, clientData: object) =>
    postData(jwt, "client_write", { clientData: clientData }),
  getClientPolicies: (jwt: string, clientId: string) =>
    postData(jwt, "getClient_Policies", { clPIN: clientId }),
};

export default ClientsService;
